<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Layout Setting Name"
                  v-model="layoutSetting.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="layoutSetting.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  v-model="layoutSetting.layoutType"
                  :items="layoutTypeList"
                  label="Layout Type..."
                  item-text="label"
                  menu-props="auto"
                  item-value="value"
                  @change="changeLayoutType"
                  :rules="rules.layoutTypeRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-select
                  v-model="layoutSetting.sessionName"
                  :items="sessionList"
                  label="Session..."
                  item-text="label"
                  hint="Please Select layout type first."
                  menu-props="auto"
                  item-value="value"
                  :readonly="layoutSetting.layoutType ? false : true"
                  :rules="rules.sessionRules"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="layoutSetting.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="layoutSetting.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="layoutSetting.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="layoutSetting.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="layoutSetting.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="layoutSetting.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <!-- <v-flex sm6 v-if="layoutSetting.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>-->
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addAccount()">
                    Add Account
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs3>Account Code</v-flex>
                  <v-flex xs3>Account Name</v-flex>
                  <v-flex xs2>Is Subtract</v-flex>
                  <v-flex xs2>Previous Trial</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(layoutSettingDetail, index) in layoutSetting.layoutSettingDetailList"
                  :key="index"
                >
                  <v-flex xs3>
                    <v-text-field
                      placeholder="Select code"
                      v-model="layoutSettingDetail.accountCode"
                      @click="showAccountList(), selectedIndex = index"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="layoutSettingDetail.accountName"
                      :loading="showAutocompleteLoading"
                      label="Name"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox v-model="layoutSettingDetail.isSubtract"></v-checkbox>
                  </v-flex>
                  <v-flex xs2>
                    <v-checkbox
                      v-model="layoutSettingDetail.isPreviousTrial"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removeAccount(index, layoutSettingDetail.id)"
                      :disabled="index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!--debit account list dialog -->
    <v-dialog v-model="showAccountListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="accountQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accName"
                label="Acccount Name"
                type="text"
                class="mr-1"
                v-model="accountQueryParams.accName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accountheadName"
                label="Account Head Name"
                type="text"
                class="mr-1"
                v-model="accountQueryParams.accountheadName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearchAccount()">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex 12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="accountHeader"
                :items="accountList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalAccountRows"
                :rows-per-page-items="accountRowsPerPageItems"
                :pagination.sync="accountPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setAccount(props.item,selectedIndex), showAccountListDialog = !showAccountListDialog"
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.accName }}</td>
                  <td>{{ props.item.accTypeName }}</td>
                  <td>{{ props.item.nature }}</td>
                  <td>{{ props.item.accounthead.accountName }}</td>
                  <td>{{ props.item.parentCode }}</td>
                  <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                  <td>{{ props.item.updatedBy }}</td>
                  <td>
                    <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                    <v-icon v-else medium color="red">cancel</v-icon>
                  </td>
                  <td></td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { chartOfAccountService } from "../../services/chart-of-account-service";
import { LayoutSettingFormRules } from "../../helpers/validation-rules";
import { layoutSettingService } from "../../services/layout-setting-service";
import { LayoutSetting, LayoutSettingDetail } from "../../models/model";

export default {
  name: "LayoutSettingDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    showAccountListDialog: false,
    showAutocompleteLoading: false,
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Layout Setting",
        disabled: false,
        to: "layout-settings",
      },
      {
        text: "Layout Setting Details",
        disabled: true,
      },
    ],
    layoutTypeList: [
      { label: "Income Statement", value: "INCOME_STATEMENT" },
      { label: "Balance Sheet", value: "BALANCE_SHEET" },
      { label: "Manufacturing Account", value: "MANUFACTURING_ACCOUNT" },
    ],
    sessionList: [
      { label: "Revenue", value: "REVENUE" },
      { label: "Cost of Good Sold", value: "COST_OF_GOOD_SOLD" },
      { label: "Other Income", value: "OTHER_INCOME" },
      { label: "Administration Expenses", value: "ADMINISTRATION_EXPENSES" },
      {
        label: "Selling & Distribution Expenses",
        value: "SELLING_DISTRIBUTION_EXPENSES",
      },
      { label: "Non-Current Asset", value: "NON_CURRENT_ASSET" },
      { label: "Current Asset", value: "CURRENT_ASSET" },
      { label: "Equity", value: "EQUITY" },
      { label: "Non-Current Liabilities", value: "NON_CURRENT_LIABILITIES" },
      { label: "Current Liabilities", value: "CURRENT_LIABILITIES" },
      { label: "Other Expenses", value: "OTHER_EXPENSES"},
      { label: "Original Cost", value: "ORIGINAL_COST" },
      { label: "Production Cost", value: "PRODUCTION_COST" },
      { label: "Production Value", value: "PRODUCTION_VALUE"},
      { label: "Value of Goods Sold", value: "VALUE_OF_GOODS_SOLD"}
    ],
    ISSessionList: [
      { label: "Revenue", value: "REVENUE" },
      { label: "Cost of Good Sold", value: "COST_OF_GOOD_SOLD" },
      { label: "Other Income", value: "OTHER_INCOME" },
      { label: "Administration Expenses", value: "ADMINISTRATION_EXPENSES" },
      {
        label: "Selling & Distribution Expenses",
        value: "SELLING_DISTRIBUTION_EXPENSES",
      },
      { label: "Other Expenses", value: "OTHER_EXPENSES"}
    ],
    BSSessionList: [
      { label: "Non-Current Asset", value: "NON_CURRENT_ASSET" },
      { label: "Current Asset", value: "CURRENT_ASSET" },
      { label: "Equity", value: "EQUITY" },
      { label: "Non-Current Liabilities", value: "NON_CURRENT_LIABILITIES" },
      { label: "Current Liabilities", value: "CURRENT_LIABILITIES" },
    ],
    MASessionList: [
      { label: "Original Cost", value: "ORIGINAL_COST" },
      { label: "Production Cost", value: "PRODUCTION_COST" },
      { label: "Production Value", value: "PRODUCTION_VALUE"},
      { label: "Value of Goods Sold", value: "VALUE_OF_GOODS_SOLD"}
    ],
    createdDate: "",
    updatedDate: "",
    responseError: "",
    saveLoading: false,
    statusFlag: true,
    rules: new LayoutSettingFormRules(),
    layoutSetting: new LayoutSetting(),
    LayoutSettingDetail: new LayoutSettingDetail(),
    oldLayoutSetting: new LayoutSetting(),
    messageDialogBox: false,
    selectedIndex: 0,
    accountQueryParams: {
      accName: "",
      code: "",
      accountheadName: "",
      isExistParent: false,
    },
    accountHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "accName" },
      { text: "Type", value: "type" },
      { text: "Nature", value: "nature" },
      { text: "Account Head", value: "accountHead.accountName" },
      { text: "Parent Code", value: "accountChild.code" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
      { text: "Status", value: "status" },
    ],
    accountPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    accountRowsPerPageItems: [25, 50, 100],
    totalAccountRows: 0,
    accountList: [],
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new Layout Setting
      this.addAccount();
    } else {
      this.getlayoutSettingDetail(id);
    }
  },
  watch: {
    accountPagination: {
      handler() {
        this.getAccountList();
      },
      deep: true,
    },
  },
  methods: {
    changeLayoutType() {
      if (this.layoutSetting.layoutType == "INCOME_STATEMENT") {
        this.sessionList = this.ISSessionList;
      } else if (this.layoutSetting.layoutType == "BALANCE_SHEET") {
        this.sessionList = this.BSSessionList;
      }else{
        this.sessionList = this.MASessionList;
      }
      let session = commonService.search(
        "value",
        this.layoutSetting.sessionName,
        this.sessionList
      );
      if (!session) this.layoutSetting.sessionName = "";
    },
    addAccount() {
      this.layoutSettingDetail = new LayoutSettingDetail();
      let layoutSettingDetail = JSON.parse(
        JSON.stringify(this.layoutSettingDetail)
      );
      this.layoutSetting.layoutSettingDetailList.push(layoutSettingDetail);
    },

    removeAccount(index, layoutSettingDetailId) {
      if (layoutSettingDetailId) {
        if (!this.layoutSetting.deleteDetailIds) {
          this.layoutSetting.deleteDetailIds = [];
        }
        this.layoutSetting.deleteDetailIds.push(layoutSettingDetailId);
      }
      this.$delete(this.layoutSetting.layoutSettingDetailList, index);
    },

    showAccountList() {
      this.accountQueryParams.accName = "";
      this.accountQueryParams.code = "";
      this.accountQueryParams.accountheadName = "";
      this.getAccountList().then(
        (this.showAccountListDialog = !this.showAccountListDialog)
      );
    },

    getAccountList() {
      this.showListLoading = true;
      let order = this.accountPagination.descending ? "desc" : "asc";
      return chartOfAccountService
        .getChartOfAccountList(
          this.accountQueryParams,
          this.accountPagination.page,
          this.accountPagination.rowsPerPage,
          this.accountPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountList = res.data.chartOfAccountList;
            this.totalAccountRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    setAccount(account, index) {
      this.layoutSetting.layoutSettingDetailList[index].accountId = account.id;
      this.layoutSetting.layoutSettingDetailList[index].accountCode =
        account.code;
      this.layoutSetting.layoutSettingDetailList[index].accountName =
        account.accName;
      this.layoutSetting.layoutSettingDetailList[index].carryOn =
        account.carryOn;
    },
    onSearchAccount() {
      this.accountPagination.page = this.accountPagination.page;
      this.accountPagination.size = this.accountPagination.rowsPerPage;
      this.getAccountList();
    },

    getlayoutSettingDetail(id) {
      layoutSettingService.getLayoutSettingDetail(id).then((res) => {
        this.layoutSetting = res.data;
        this.changeLayoutType();
        this.createdDate = commonService.formatDate(
          new Date(this.layoutSetting.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.layoutSetting.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.oldLayoutSetting = JSON.parse(JSON.stringify(res.data));
      });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.layoutSetting.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        layoutSettingService
          .saveLayoutSetting(this.layoutSetting)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.layoutSetting.id) {
        this.layoutSetting = new LayoutSetting();
        this.statusFlag = true;
      } else {
        this.layoutSetting = JSON.parse(JSON.stringify(this.oldLayoutSetting));
        this.statusFlag = this.layoutSetting.status == "ACTIVE" ? true : false;
      }
      this.changeLayoutType();
    },

    goBack() {
      this.$router.push("/layout-settings");
    },
  },
};
</script>
